import type { ServerColDef } from '@cmg/data-grid';
import { createValueFormatter } from '@cmg/data-grid';

import type { FirmInvestorContactsGridItemFragment } from '../graphql/__generated__';

export const valueFormatter = createValueFormatter<
  FirmInvestorContactsGridItemFragment,
  FirmInvestorContactsGridItemFragment['email1']
>();

export const investorEmployeeEmailColDef: ServerColDef<FirmInvestorContactsGridItemFragment> = {
  field: 'email1',
  headerName: 'Email Address (Primary)',
  valueFormatter,
};
